var _RSConfig;

$(function() {
  CartJS.init(CART_JSON);
});

var variantTextNew;
var animatedSkinType;
function getUrlParam(sParam) {
  var sPageURL = window.location.search.substring(1),
  sURLVariables = sPageURL.split('&'),
  sParameterName,
  i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? null : decodeURIComponent(sParameterName[1]);
    }
  }
  return null;
};

let upsellParam = getUrlParam('upsell');
const UPSELL_NUM = upsellParam != null ? upsellParam : 0;

$(document).ready(() => {

  //
  // PHOTO ZOOM
  ///////////////////

  $( '.reg__photo' ).each(function( index ) {
    var img_url = $(this).data('thumb').replace('_200x200_crop_center', '_1000x1000_crop_center');
    $(this)
      .zoom({
        url: img_url,
        on: 'click'
      });
  });

  // 
  // UPSELL
  ////////// 
  var productHasSellingPlans = false;
  if (_RSConfig) {
    if (_RSConfig.product.selling_plan_groups.length) {
      // there is a subscription plan, but show upsell anyways...
      productHasSellingPlans = true;
      $('.product__upsell').show();
    } else {
      $('.product__upsell').show();
    }
  } else {
    $('.product__upsell').show();
  }
  
  $('.product__upsell .upsell-item').on('click', (e) => {
    $(e.currentTarget).toggleClass('selected');
    updateYourItemsUpsell();
  })

  if (typeof acne90DayKit !== 'undefined') {
    productAccessory = "2x "+ productAccessory; 
  }
  
  let oldYourItemsImageSelect = '';
  let oldYourItemsProductAccessory = '';
  let oldYourItemsDisplayProductType = '';
  // keep "let oldYourItems..." above "productSelectUpdate()" to avoid "Uncaught ReferenceError: Cannot access '...' before initialization"

  if (document.URL.indexOf("gift-card") == -1 && document.URL.indexOf("sample-kit") == -1 && document.URL.indexOf("travel-moisturizer") == -1) { // don't update gift card amount select
    productSelectUpdate(); // update skin select
  }
 
  function updateMobileCarouselZoom(variant) {
    if (typeof variantImageSwap == 'function') variantImageSwap(variant);
  }
  
  function updateYourItemsUpsell() {
    // console.log('updateYourItemsUpsell');
    if (oldYourItemsImageSelect == '') return;
    updateYourItems(oldYourItemsImageSelect, oldYourItemsProductAccessory, oldYourItemsDisplayProductType);
  }

  function updateYourItems(imageSelect, productAccessory, displayProductType) {
    console.log('updateYourItems');
    oldYourItemsImageSelect = imageSelect;
    oldYourItemsProductAccessory = productAccessory;
    oldYourItemsDisplayProductType = displayProductType;
    
    let variantText = '';
    let variantTextNew = '';
    let displayProductTypeTrimmed = displayProductType.replace(', ', '').replace(',', '');

    const bogoProduct = product.tags.includes('BOGO');

    let selectedUpsellItems = $('.upsell-item.selected').map(function () {
      let title = $(this).data('full-title');
      title = title.replace('(10 Percent Off)', '');
      title = title.replace('(10 Percent)', '');
      title = title.replace('(15 Percent Off)', '');
      title = title.replace('(15 Percent)', '');
      title = title.replace('(20 Percent Off)', '');
      title = title.replace('(20 Percent)', '');
      title = title.replace('Hydrating ', '');
      title = title.replace('Exfoliating ', '');
      title = title.replace('Broad Spectrum ', '');
      title = title.trim();
      return `<span class="your-item">${ title }</span>`;
    }).get().join('');
    // console.log('selectedUpsellItems: ' + selectedUpsellItems);
    if (PRODUCT_HANDLE == 'lightweight-broad-spectrum-sunscreen') {
      variantText = `${ imageSelect } SPF 30 Sunscreen`;
      variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
        `<span class="your-item">${ imageSelect } SPF 30 Sunscreen</span>` +
        selectedUpsellItems +
      `</p>`;
    } else if (PRODUCT_HANDLE == 'spf-30-sunscreen-redness-calming-mask') {
      variantText = `${ imageSelect } SPF 30 Sunscreen`;
      variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
        `<span class="your-item">${ imageSelect } SPF 30 Sunscreen</span>` +
        `<span class="your-item">Redness Calming Mask</span>` +
        selectedUpsellItems +
      `</p>`;
    } else if (PRODUCT_HANDLE == 'retinol-summer-kit') {
      variantText = `${ imageSelect } SPF 30 Sunscreen`;
      variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
        `<span class="your-item">${ imageSelect } SPF 30 Sunscreen</span>` +
        `<span class="your-item">Retinol Treatment</span>` +
        selectedUpsellItems +
      `</p>`;
    } else if (PRODUCT_HANDLE == 'redness-calming-summer-kit') {
      variantText = `${ imageSelect } SPF 30 Sunscreen`;
      variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
        `<span class="your-item">${ imageSelect } SPF 30 Face Sunscreen</span>` +
        `<span class="your-item">Redness Calming Mask</span>` +
        `<span class="your-item">SPF 40 Body Sunscreen</span>` +
        selectedUpsellItems +
      `</p>`;
    } else if (PRODUCT_HANDLE == 'summer-skin-kit') {
      variantText = `${ imageSelect } SPF 30 Sunscreen`;
      variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
        `<span class="your-item">${ imageSelect } SPF 30 Face Sunscreen</span>` +
        `<span class="your-item">Exfoliating Glycolic Peel</span>` +
        `<span class="your-item">SPF 40 Body Sunscreen</span>` +
        selectedUpsellItems +
      `</p>`;
    } else if (PRODUCT_HANDLE == 'anti-aging-winter-skin-kit'){
      switch (imageSelect) {
        case 'VDry':
          variantText = productAccessory + 'Retinol Treatment' + 'Moisturizing Concentrate';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Retinol Treatment</span>` +
            `<span class="your-item">Moisturizing Concentrate</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Normal':
          variantText = productAccessory + 'Retinol Treatment' + 'Daily Moisturizing Cream';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Retinol Treatment</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
      }
    } else if (PRODUCT_HANDLE == 'redness-control-starter-trio' || PRODUCT_HANDLE == 'anti-aging-starter-trio'){
      switch (imageSelect) {
        case 'VDry':
          variantText = productAccessory + 'Hydrating Cream Cleanser (30ml)' + displayProductType + ' (30ml) and Moisturizing Concentrate (15ml)';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Hydrating Cream Cleanser (30ml)</span>` +
            (displayProductTypeTrimmed != '' ? `<span class="your-item">${ displayProductTypeTrimmed } (30ml)</span>` : '') +
            `<span class="your-item">Moisturizing Concentrate (15ml)</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Normal':
          variantText = productAccessory + 'Hydrating Cream Cleanser (30ml)' + displayProductType + '(30ml) and Daily Moisturizing Cream (15ml)';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Hydrating Cream Cleanser (30ml)</span>` +
            (displayProductTypeTrimmed != '' ? `<span class="your-item">${ displayProductTypeTrimmed } (30ml)</span>` : '') +
            `<span class="your-item">Daily Moisturizing Cream (15ml)</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Combo':
          variantText = productAccessory + 'Refreshing Gel Cleanser (30ml)' + displayProductType + ' (30ml) and Daily Moisturizing Cream (15ml)';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Refreshing Gel Cleanser (30ml)</span>` +
            (displayProductTypeTrimmed != '' ? `<span class="your-item">${ displayProductTypeTrimmed } (30ml)</span>` : '') +
            `<span class="your-item">Daily Moisturizing Cream (15ml)</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Oily':
          variantText = productAccessory + 'Refreshing Gel Cleanser (30ml)' + displayProductType + ' (30ml) and Lightweight Moisturizing Lotion (15ml)';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Refreshing Gel Cleanser (30ml)</span>` +
            (displayProductTypeTrimmed != '' ? `<span class="your-item">${ displayProductTypeTrimmed } (30ml)</span>` : '') +
            `<span class="your-item">Lightweight Moisturizing Lotion (15ml)</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
      }
    } else if (PRODUCT_HANDLE == 'anti-aging-full-sized-trio-and-mini-trio-kit-m' || PRODUCT_HANDLE == 'redness-control-full-sized-trio-and-mini-trio-kit-m' ) {
      switch (imageSelect) {
        case 'VDry':
          variantText = productAccessory + 'Hydrating Cream Cleanser' + displayProductType + ' Moisturizing Concentrate, <strong>Travel Micellar Water</strong>, Travel' + displayProductType.replace(', Anti', ' Anti') + ' and Travel Moisturizing Concentrate';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Hydrating Cream Cleanser</span>` +
            `<span class="your-item">${ displayProductTypeTrimmed }</span>` +
            `<span class="your-item">Moisturizing Concentrate</span>` +
            selectedUpsellItems +
          `</div>`;
          break;
        case 'Normal':
          variantText = productAccessory + 'Hydrating Cream Cleanser' + displayProductType + ' Daily Moisturizing Cream, <strong>Travel Micellar Water</strong>, Travel' + displayProductType.replace(', Anti', ' Anti') + ' and Travel Daily Moisturizing Cream';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Hydrating Cream Cleanser</span>` +
            `<span class="your-item">${ displayProductTypeTrimmed }</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Combo':
          variantText = productAccessory + 'Refreshing Gel Cleanser' + displayProductType + ' Daily Moisturizing Cream, <strong>Travel Gel Cleanser</strong>, Travel' + displayProductType.replace(', Anti', ' Anti') + ' and Travel Daily Moisturizing Cream';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Refreshing Gel Cleanser</span>` +
            `<span class="your-item">${ displayProductTypeTrimmed }</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Oily':
          variantText = productAccessory + 'Refreshing Gel Cleanser' + displayProductType + ' Lightweight Moisturizing Lotion, <strong>Travel Gel Cleanser</strong>, Travel' + displayProductType.replace(', Anti', ' Anti') + ' and Travel Lightweight Moisturizing Lotion';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Refreshing Gel Cleanser</span>` +
            `<span class="your-item">${ displayProductTypeTrimmed }</span>` +
            `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
      }
    } else if (PRODUCT_HANDLE == 'summer-skincare-bundle'){
      variantText = '';
      switch (imageSelect) {
        case 'VDry':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Hydrating Cream Cleanser</span>` +
            `<span class="your-item">Moisturizing Concentrate</span>` +
            `<span class="your-item">Redness Calming Mask</span>` +
            `<span class="your-item">Corrector V2</span>` +
            `<span class="your-item">Weightless Body Sunscreen SPF40</span>` +
            `<span class="your-item">Tote bag (while supplies last)</span>` +
            selectedUpsellItems +
          `</div>`;
          break;
        case 'Normal':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Hydrating Cream Cleanser</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            `<span class="your-item">Redness Calming Mask</span>` +
            `<span class="your-item">Corrector V2</span>` +
            `<span class="your-item">Weightless Body Sunscreen SPF40</span>` +
            `<span class="your-item">Tote bag (while supplies last)</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Combo':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Refreshing Gel Cleanser</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            `<span class="your-item">Redness Calming Mask</span>` +
            `<span class="your-item">Corrector V2</span>` +
            `<span class="your-item">Weightless Body Sunscreen SPF40</span>` +
            `<span class="your-item">Tote bag (while supplies last)</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Oily':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Refreshing Gel Cleanser</span>` +
            `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
            `<span class="your-item">Redness Calming Mask</span>` +
            `<span class="your-item">Corrector V2</span>` +
            `<span class="your-item">Weightless Body Sunscreen SPF40</span>` +
            `<span class="your-item">Tote bag (while supplies last)</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
      }
      
    } else if (PRODUCT_HANDLE == 'cleansing-and-moisturizing-duo'){
      variantText = '';
      switch (imageSelect) {
        case 'VDry':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Hydrating Cream Cleanser</span>` +
            `<span class="your-item">Moisturizing Concentrate</span>` +
            selectedUpsellItems +
          `</div>`;
          break;
        case 'Normal':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Hydrating Cream Cleanser</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Combo':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Refreshing Gel Cleanser</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Oily':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Refreshing Gel Cleanser</span>` +
            `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
      }
      
    } else if (PRODUCT_HANDLE == 'correcting-and-moisturizing-duo'){
      variantText = '';
      switch (imageSelect) {
        case 'VDry':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Corrector V2</span>` +
            `<span class="your-item">Moisturizing Concentrate</span>` +
            selectedUpsellItems +
          `</div>`;
          break;
        case 'Normal':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Corrector V2</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Combo':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Corrector V2</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Oily':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Corrector V2</span>` +
            `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
      }

    } else if (PRODUCT_HANDLE == 'exfoliating-and-moisturizing-duo'){
      variantText = '';
      switch (imageSelect) {
        case 'VDry':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Exfoliating Glycolic Peel</span>` +
            `<span class="your-item">Moisturizing Concentrate</span>` +
            selectedUpsellItems +
          `</div>`;
          break;
        case 'Normal':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Exfoliating Glycolic Peel</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Combo':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Exfoliating Glycolic Peel</span>` +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Oily':
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            `<span class="your-item">Exfoliating Glycolic Peel</span>` +
            `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
      }
    } else if (PRODUCT_HANDLE == 'redness-calming-mask-free-moisturizer') {
      variantText = '';
      if (imageSelect == 'Normal') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Redness Calming Mask</span>` +
          `<span class="your-item">Daily Moisturizing Cream</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Redness Calming Mask</span>` +
          `<span class="your-item">Moisturizing Concentrate</span>` +
          selectedUpsellItems +
        `</div>`;
      } else if (imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Redness Calming Mask</span>` +
          `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
          selectedUpsellItems +
        `</p>`;
      }
    } else if (PRODUCT_HANDLE == 'retinol-neck-cream-free-moisturizer') {
      variantText = '';
      if (imageSelect == 'Normal') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Retinol Neck Cream</span>` +
          `<span class="your-item">Daily Moisturizing Cream</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Retinol Neck Cream</span>` +
          `<span class="your-item">Moisturizing Concentrate</span>` +
          selectedUpsellItems +
        `</div>`;
      } else if (imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Retinol Neck Cream</span>` +
          `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
          selectedUpsellItems +
        `</p>`;
      }
    } else if (PRODUCT_HANDLE == 'retinol-neck-cream-refill-free-moisturizer-gift') {
      variantText = '';
      if (imageSelect == 'Normal') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Retinol Neck Cream Refill</span>` +
          `<span class="your-item">Daily Moisturizing Cream</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Retinol Neck Cream Refill</span>` +
          `<span class="your-item">Moisturizing Concentrate</span>` +
          selectedUpsellItems +
        `</div>`;
      } else if (imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Retinol Neck Cream Refill</span>` +
          `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
          selectedUpsellItems +
        `</p>`;
      }
    } else if (PRODUCT_HANDLE == 'retinol-treatment-free-moisturizer') {
      variantText = '';
      if (imageSelect == 'Normal') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Retinol Treatment</span>` +
          `<span class="your-item">Daily Moisturizing Cream</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Retinol Treatment</span>` +
          `<span class="your-item">Moisturizing Concentrate</span>` +
          selectedUpsellItems +
        `</div>`;
      } else if (imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Retinol Treatment</span>` +
          `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
          selectedUpsellItems +
        `</p>`;
      }
    } else if (PRODUCT_HANDLE == 'the-corrector-v2-free-moisturizer') {
      variantText = '';
      if (imageSelect == 'Normal') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">The Corrector V2</span>` +
          `<span class="your-item">Daily Moisturizing Cream</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">The Corrector V2</span>` +
          `<span class="your-item">Moisturizing Concentrate</span>` +
          selectedUpsellItems +
        `</div>`;
      } else if (imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">The Corrector V2</span>` +
          `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
          selectedUpsellItems +
        `</p>`;
      }

    } else if (PRODUCT_HANDLE == 'anti-redness-and-moisturizing-duo') {
      variantText = '';
      if (imageSelect == 'Normal' || imageSelect == 'Combo') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Redness Serum</span>` +
          `<span class="your-item">Daily Moisturizing Cream</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Redness Serum</span>` +
          `<span class="your-item">Moisturizing Concentrate</span>` +
          selectedUpsellItems +
        `</div>`;
      } else if (imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Redness Serum</span>` +
          `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
          selectedUpsellItems +
        `</p>`;
      }
    } else if (PRODUCT_HANDLE == 'body-lotion-hand-balm-and-moisturizer-trio') {
      variantText = '';
      if (imageSelect == 'Normal' || imageSelect == 'Combo') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Hand Balm</span>` +
          `<span class="your-item">Hydrating Body Lotion</span>` +
          `<span class="your-item">Daily Moisturizing Cream</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Hand Balm</span>` +
          `<span class="your-item">Hydrating Body Lotion</span>` +
          `<span class="your-item">Moisturizing Concentrate</span>` +
          selectedUpsellItems +
        `</div>`;
      } else if (imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Hand Balm</span>` +
          `<span class="your-item">Hydrating Body Lotion</span>` +
          `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
          selectedUpsellItems +
        `</p>`;
      }
    } else if (PRODUCT_HANDLE == 'anti-aging-and-cleansing-duo') {
      variantText = '';
      if (imageSelect == 'Normal' || imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Aging Reparative Serum</span>` +
          `<span class="your-item">Hydrating Cream Cleanser</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'Combo' || imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Aging Reparative Serum</span>` +
          `<span class="your-item">Refreshing Gel Cleanser</span>` +
          selectedUpsellItems +
        `</div>`;
      } 
    }  else if (PRODUCT_HANDLE == 'anti-aging-and-moisturizing-duo') {
      variantText = '';
      if (imageSelect == 'Normal' || imageSelect == 'Combo') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Aging Reparative Serum</span>` +
          `<span class="your-item">Daily Moisturizing Cream</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Aging Reparative Serum</span>` +
          `<span class="your-item">Moisturizing Concentrate</span>` +
          selectedUpsellItems +
        `</div>`;
      } else if (imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Aging Reparative Serum</span>` +
          `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
          selectedUpsellItems +
        `</p>`;
      }
    } else if (PRODUCT_HANDLE == 'anti-redness-and-moisturizing-duo-save-40' || PRODUCT_HANDLE == 'anti-redness-and-moisturizing-duo-save') {
      variantText = '';
      if (imageSelect == 'Normal' || imageSelect == 'Combo') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Redness Serum</span>` +
          `<span class="your-item">Daily Moisturizing Cream</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Redness Serum</span>` +
          `<span class="your-item">Moisturizing Concentrate</span>` +
          selectedUpsellItems +
        `</div>`;
      } else if (imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Redness Serum</span>` +
          `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
          selectedUpsellItems +
        `</p>`;
      }
    } else if (PRODUCT_HANDLE == 'anti-aging-and-moisturizing-duo-save-40' || PRODUCT_HANDLE == 'anti-aging-and-moisturizing-duo-save') {
      variantText = '';
      if (imageSelect == 'Normal' || imageSelect == 'Combo') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Aging Reparative Serum</span>` +
          `<span class="your-item">Daily Moisturizing Cream</span>` +
          selectedUpsellItems +
        `</p>`;
      } else if (imageSelect == 'VDry') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Aging Reparative Serum</span>` +
          `<span class="your-item">Moisturizing Concentrate</span>` +
          selectedUpsellItems +
        `</div>`;
      } else if (imageSelect == 'Oily') {
        variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
          `<span class="your-item">Anti-Aging Reparative Serum</span>` +
          `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
          selectedUpsellItems +
        `</p>`;
      }
      

    } 
    else if (PRODUCT_HANDLE.indexOf('acne-fix-kit') > -1) {
      variantText = '';
      let skinTypeProducts = '';
      let bogoQty = bogoProduct ? 'x2 ' : '';
      if (imageSelect == 'Combo') {
        skinTypeProducts = `
            <span class="your-item">Refreshing Gel Cleanser ${bogoQty}</span>
            <span class="your-item">Daily Moisturizing Cream ${bogoQty}</span>
        `;
      } 
      else if (imageSelect == 'VDry') {
        skinTypeProducts = `
            <span class="your-item">Hydrating Cream Cleanser ${bogoQty}</span>
            <span class="your-item">Moisturizing Concentrate ${bogoQty}</span>
        `;
      } else if (imageSelect == 'Oily') {
        skinTypeProducts = `
            <span class="your-item">Refreshing Gel Cleanser ${bogoQty}</span>
            <span class="your-item">Lightweight Moisturizing Lotion ${bogoQty}</span>
        `;
      }
      else {
        skinTypeProducts = `
            <span class="your-item">Hydrating Cream Cleanser ${bogoQty}</span>
            <span class="your-item">Daily Moisturizing Cream ${bogoQty}</span>
        `;
      }
      variantTextNew += `
        <label class="label">Your Items</label>
        <div class="your-items">
          ${skinTypeProducts}
          <span class="your-item">Comprehensive Acne Treatment ${bogoQty ? 'x4' : 'x2'}</span>
          <span class="your-item">Exfoliating Glycolic Peel ${bogoQty}</span>
          <span class="your-item">The Corrector V2 ${bogoQty}</span>
          <span class="your-item">Makeup Bag ${bogoQty}</span>
        </div>
      `
    } 
    else if (PRODUCT_HANDLE.indexOf('anti-aging-to-go') > -1) {
      variantText = '';
      let skinTypeProducts = '';
      let bogoQty = bogoProduct ? 'x2 ' : '';
      if (imageSelect == 'Combo') {
        skinTypeProducts = `
            <span class="your-item">Refreshing Gel Cleanser ${bogoQty}</span>
            <span class="your-item">Travel Refreshing Gel Cleanser ${bogoQty}</span>
            <span class="your-item">Daily Moisturizing Cream ${bogoQty}</span>
            <span class="your-item">Travel Daily Moisturizing Cream ${bogoQty}</span>
        `;
      } 
      else if (imageSelect == 'VDry') {
        skinTypeProducts = `
            <span class="your-item">Hydrating Cream Cleanser ${bogoQty}</span>
            <span class="your-item">Travel Hydrating Cream Cleanser ${bogoQty}</span>
            <span class="your-item">Moisturizing Concentrate ${bogoQty}</span>
            <span class="your-item">Travel Moisturizing Concentrate ${bogoQty}</span>
        `;
      } else if (imageSelect == 'Oily') {
        skinTypeProducts = `
            <span class="your-item">Refreshing Gel Cleanser ${bogoQty}</span>
            <span class="your-item">Travel Refreshing Gel Cleanser ${bogoQty}</span>
            <span class="your-item">Lightweight Moisturizing Lotion ${bogoQty}</span>
            <span class="your-item">Travel Lightweight Moisturizing Lotion ${bogoQty}</span>
        `;
      }
      else {
        skinTypeProducts = `
            <span class="your-item">Hydrating Cream Cleanser ${bogoQty}</span>
            <span class="your-item">Travel Hydrating Cream Cleanser ${bogoQty}</span>
            <span class="your-item">Daily Moisturizing Cream ${bogoQty}</span>
            <span class="your-item">Travel Daily Moisturizing Cream ${bogoQty}</span>
        `;
      }
      variantTextNew += `
        <label class="label">Your Items</label>
        <div class="your-items">
          ${skinTypeProducts}
          <span class="your-item">Anti-Aging Serum ${bogoQty}</span>
          <span class="your-item">Travel Anti-Aging Serum ${bogoQty}</span>
          <span class="your-item">Travel Micellar Water ${bogoQty}</span>
          <span class="your-item">Eye Repair Treatment Sample ${bogoQty}</span>
          <span class="your-item">Makeup Bag ${bogoQty}</span>
        </div>
      `
    } 
    else if (PRODUCT_HANDLE.indexOf('redness-control-to-go') > -1) {
      variantText = '';
      let skinTypeProducts = '';
      let bogoQty = bogoProduct ? 'x2 ' : '';
      if (imageSelect == 'Combo') {
        skinTypeProducts = `
            <span class="your-item">Refreshing Gel Cleanser ${bogoQty}</span>
            <span class="your-item">Travel Refreshing Gel Cleanser ${bogoQty}</span>
            <span class="your-item">Daily Moisturizing Cream ${bogoQty}</span>
            <span class="your-item">Travel Daily Moisturizing Cream ${bogoQty}</span>
        `;
      } 
      else if (imageSelect == 'VDry') {
        skinTypeProducts = `
            <span class="your-item">Hydrating Cream Cleanser ${bogoQty}</span>
            <span class="your-item">Travel Hydrating Cream Cleanser ${bogoQty}</span>
            <span class="your-item">Moisturizing Concentrate ${bogoQty}</span>
            <span class="your-item">Travel Moisturizing Concentrate ${bogoQty}</span>
        `;
      } else if (imageSelect == 'Oily') {
        skinTypeProducts = `
            <span class="your-item">Refreshing Gel Cleanser ${bogoQty}</span>
            <span class="your-item">Travel Refreshing Gel Cleanser ${bogoQty}</span>
            <span class="your-item">Lightweight Moisturizing Lotion ${bogoQty}</span>
            <span class="your-item">Travel Lightweight Moisturizing Lotion ${bogoQty}</span>
        `;
      }
      else {
        skinTypeProducts = `
            <span class="your-item">Hydrating Cream Cleanser ${bogoQty}</span>
            <span class="your-item">Travel Hydrating Cream Cleanser ${bogoQty}</span>
            <span class="your-item">Daily Moisturizing Cream ${bogoQty}</span>
            <span class="your-item">Travel Daily Moisturizing Cream ${bogoQty}</span>
        `;
      }
      variantTextNew += `
        <label class="label">Your Items</label>
        <div class="your-items">
          ${skinTypeProducts}
          <span class="your-item">Anti-Redness Serum ${bogoQty}</span>
          <span class="your-item">Travel Anti-Redness Serum ${bogoQty}</span>
          <span class="your-item">Travel Micellar Water ${bogoQty}</span>
          <span class="your-item">Redness Calming Mask Sample ${bogoQty}</span>
          <span class="your-item">Makeup Bag ${bogoQty}</span>
        </div>
      `
    } else if (PRODUCT_HANDLE.indexOf('anti-aging-trio-free-travel-collection') > -1 || PRODUCT_HANDLE.indexOf('redness-control-trio-free-travel-collection') > -1) {
      variantText = '';
      const skinType = PRODUCT_HANDLE.indexOf('redness-control-trio-free-travel-collection') > -1 ? 'Anti-Redness' : 'Anti-aging'
      let skinTypeProducts = '';
      if (imageSelect == 'Combo') {
        skinTypeProducts = `
            <span class="your-item">Refreshing Gel Cleanser</span>
            <span class="your-item">Travel Refreshing Gel Cleanser</span>
            <span class="your-item">Daily Moisturizing Cream</span>
            <span class="your-item">Travel Daily Moisturizing Cream</span>
        `;
      } 
      else if (imageSelect == 'VDry') {
        skinTypeProducts = `
            <span class="your-item">Hydrating Cream Cleanser</span>
            <span class="your-item">Travel Hydrating Cream Cleanser</span>
            <span class="your-item">Moisturizing Concentrate</span>
            <span class="your-item">Travel Moisturizing Concentrate</span>
        `;
      } else if (imageSelect == 'Oily') {
        skinTypeProducts = `
            <span class="your-item">Refreshing Gel Cleanser</span>
            <span class="your-item">Travel Refreshing Gel Cleanser</span>
            <span class="your-item">Lightweight Moisturizing Lotion</span>
            <span class="your-item">Travel Lightweight Moisturizing Lotion</span>
        `;
      }
      else {
        skinTypeProducts = `
            <span class="your-item">Hydrating Cream Cleanser</span>
            <span class="your-item">Travel Hydrating Cream Cleanser</span>
            <span class="your-item">Daily Moisturizing Cream</span>
            <span class="your-item">Travel Daily Moisturizing Cream</span>
        `;
      }
      variantTextNew += `
        <label class="label">Your Items</label>
        <div class="your-items">
          ${skinTypeProducts}
          <span class="your-item">${skinType} Serum</span>
          <span class="your-item">Travel ${skinType} Serum</span>
          <span class="your-item">Travel Micellar Water</span>
        </div>
      `
    } else if (PRODUCT_HANDLE.indexOf('acne-fix-duo') > -1) {
      variantText = '';
      let skinTypeProducts = '';
      if (imageSelect == 'Oily') {
        skinTypeProducts = `
            <span class="your-item">Refreshing Gel Cleanser</span>
        `;
      } else {
        skinTypeProducts = `
            <span class="your-item">Hydrating Cream Cleanser</span>
        `;
      }
      variantTextNew += `
        <label class="label">Your Items</label>
        <div class="your-items">
          ${skinTypeProducts}
          <span class="your-item">Comprehensive Acne Treatment</span>
        </div>
      `
    } 
    else {
      // Default

      if (PRODUCT_HANDLE == 'travel-essentials' ) {
        productAccessory = "Deluxe Travel Bag";
        displayProductTypeTrimmed = "Micellar Water"
      }
      
      switch (imageSelect) {
        case 'VDry':
          variantText = productAccessory + 'Hydrating Cream Cleanser' + displayProductType + ' and Moisturizing Concentrate';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Hydrating Cream Cleanser</span>` +
            (displayProductTypeTrimmed != '' ? `<span class="your-item">${ displayProductTypeTrimmed }</span>` : '') +
            `<span class="your-item">Moisturizing Concentrate</span>` +
            selectedUpsellItems +
          `</div>`;
          break;
        case 'Normal':
          variantText = productAccessory + 'Hydrating Cream Cleanser' + displayProductType + ' and Daily Moisturizing Cream';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Hydrating Cream Cleanser</span>` +
            (displayProductTypeTrimmed != '' ? `<span class="your-item">${ displayProductTypeTrimmed }</span>` : '') +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Combo':
          variantText = productAccessory + 'Refreshing Gel Cleanser' + displayProductType + ' and Daily Moisturizing Cream';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Refreshing Gel Cleanser</span>` +
            (displayProductTypeTrimmed != '' ? `<span class="your-item">${ displayProductTypeTrimmed }</span>` : '') +
            `<span class="your-item">Daily Moisturizing Cream</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
        case 'Oily':
          variantText = productAccessory + 'Refreshing Gel Cleanser' + displayProductType + ' and Lightweight Moisturizing Lotion';
          variantTextNew = `<label class="label">Your Items</label><div class="your-items">` +
            (productAccessory ? `<span class="your-item">${ productAccessory.replace(', ', '') }</span>` : '') +
            `<span class="your-item">Refreshing Gel Cleanser</span>` +
            (displayProductTypeTrimmed != '' ? `<span class="your-item">${ displayProductTypeTrimmed }</span>` : '') +
            `<span class="your-item">Lightweight Moisturizing Lotion</span>` +
            selectedUpsellItems +
          `</p>`;
          break;
      }
    }
    // console.log("UPSELL: " + selectedUpsellItems + "");
    $('.variant-info small').html(variantText);
    $('.variant-info-new').html(variantTextNew);
  }

  function productSelectUpdate() {
    // const isSampleProduct = document.URL.indexOf("sample-kit") != -1;
    const urlParams = new URLSearchParams(window.location.search);
    var variantId = 0;
    if (urlParams.has('variant')){
      variantId = urlParams.get('variant');
    }
    //2. get variant
    var i;
    var variant;
    for (i = 0; i < product.variants.length; i++) {
      var temp_variant = product.variants[i];
      if (""+temp_variant.id === ""+variantId){
        variant = temp_variant; break;
      }
    }
    //3. update product price
    if (variant != undefined && variant.price != undefined){
      var price = `$${ variant.price / 100 }`;
      if (variant.price % 100 > 0) price = `$${ (variant.price / 100).toFixed(2) }`;
      $('#product-price-mobile').text(price);
      $('#product-price').text(price);

      if (variant.compare_at_price && variant.compare_at_price != variant.price) {
        var compare_price = `$${ variant.compare_at_price / 100 }`;
        if (variant.compare_at_price % 100 > 0) compare_price = `$${ (variant.compare_at_price / 100).toFixed(2) }`;
        $('.product__price .on-sale').text(compare_price);
        $('.mobile-price .on-sale').text(compare_price);

        let save = variant.compare_at_price - variant.price;
        if (save && save > 0) {
          var yousave = `$${ save / 100 }`;
          if (save % 100 > 0) yousave = `$${ (save / 100).toFixed(2) }`;
        }
        $('.yousave .money').text(yousave);
      }
     
    }
    //4. update product image
    //Product Image Change

    var flavour = $('.product-select option:selected').text().trim();
    var skintype = $.trim(flavour);

    var hasVariantInfo = false;
    if (typeof productType !== 'undefined') {
      var hasVariantInfo = true; 
      if (productType !== 'Acne') {
        var producttype = productType + " Serum,"; 
      } else if (otherAccessoryProduct && otherAccessoryProduct != '') {
        /**/
        var producttype = "2x " + otherAccessoryProduct;
        if (productAccessory.indexOf('2x ') > -1) productAccessory = productAccessory.slice(3); // remove '2x '
      } else {
        var producttype = "";
      }
    }
    if (typeof productType !== 'undefined' && typeof productTitle !== 'undefined' && productTitle == "Travel Essentials"){
      var producttype = "";
    }
    var displayProductType = producttype || "";
    if (displayProductType != ""){
      displayProductType = ", " + displayProductType;
    }
    $('.variant-images .product__photo').removeClass('slick-active').removeClass('slick-current').css({'z-index' : '998', 'opacity' : '0'});

    var imageSelect = '';
    if (skintype.includes('Normal to Dry or Combination') || skintype.includes('Normal to Dry') || skintype.includes('Normal')){
      imageSelect = 'Normal';
      updateMobileCarouselZoom("normal");
    } else if (skintype.includes('Oily')){
      imageSelect = 'Oily';
      updateMobileCarouselZoom("oily");
    } else if (skintype.includes('Combination') || skintype.includes('Combo')){
      imageSelect = 'Combo';
      updateMobileCarouselZoom("combo");
    } else if (skintype.includes('Very Dry')){
      imageSelect = 'VDry';
      updateMobileCarouselZoom("dry");
    }
    if (['redness-calming-mask-free-moisturizer','retinol-neck-cream-free-moisturizer','retinol-neck-cream-refill-free-moisturizer-gift','retinol-treatment-free-moisturizer','the-corrector-v2-free-moisturizer'].includes(PRODUCT_HANDLE)) {
      var hasVariantInfo = true;
      productAccessory = '';
      if (skintype.includes('Daily Moisturizing Cream')){
        imageSelect = 'Normal';
        updateMobileCarouselZoom("normal");
      } else if (skintype.includes('Lightweight Moisturizing Lotion')){
        imageSelect = 'Oily';
        updateMobileCarouselZoom("oily");
      } else if (skintype.includes('Moisturizing Concentrate')){
        imageSelect = 'VDry';
        updateMobileCarouselZoom("dry");
      }
    }

    $( ".variant-images .product__photo" ).each(function() {
      var image_id = $(this).data('thumb');
      if (image_id.indexOf(imageSelect) >= 0) {
        $(this).addClass('slick-current slick-active').css({'z-index' : '999', 'opacity' : '1'});
      }
    });

    if (product.tags.includes('shade-select')) {
      console.log("updateYourItems(shade-select)");
      let isSkinSelcted = $('#product-skin-select').val() != null;
      let isTintSelcted = $('#product-select').val() != '';

      console.log($('#product-skin-select').val() + " / " + $('#product-select').val());

      if (!animatedSkinType) {
        $('#product-select').css("cssText", "width: 100% !important;");
        $('.selector-wrapper').css({ 'width': '100%' });
        $('.desktop-button').css({ 'max-width': '0%' });
          animatedSkinType = true;
        $('.selector-wrapper').animate({ 'width': '170px', queue: 'add-to-cart-open' }, 400, 'swing');
        $('.desktop-button').animate({ 'max-width': '100%', queue: 'add-to-cart-open' }, 400, 'swing');
        $('.selector-wrapper, .desktop-button').dequeue('add-to-cart-open');
      }

      if (!isTintSelcted) {
        $('#btn-add_to_cart').prop("disabled", true).html('<span data-add-to-cart-text><span class="disabled-cart-text-sm">SHADE</span><span class="disabled-cart-text-lg">CHOOSE YOUR SHADE</span></span>');
        $('#btn-add_to_cart2').prop("disabled", true).html('<span data-add-to-cart-text><span class="disabled-cart-text-sm">SHADE</span><span class="disabled-cart-text-lg">CHOOSE YOUR SHADE</span></span>');
      } else if (!isSkinSelcted) {
        $('#btn-add_to_cart').prop("disabled", true).html('<span data-add-to-cart-text><span class="disabled-cart-text-sm">SKIN</span><span class="disabled-cart-text-lg">CHOOSE YOUR SKIN TYPE</span></span>');
        $('#btn-add_to_cart2').prop("disabled", true).html('<span data-add-to-cart-text><span class="disabled-cart-text-sm">SKIN</span><span class="disabled-cart-text-lg">CHOOSE YOUR SKIN TYPE</span></span>');
      } else {
        $('#btn-add_to_cart').prop("disabled", false).text("Add to Cart");
        $('#btn-add_to_cart2').prop("disabled", false).text("Add to Cart"); 
      }
      console.log(`updateYourItems(${$('#product-skin-select').val()}, ${$('#product-select').data('variant-title')}, "");`);
      switch ($('#product-skin-select').val()) {
        case "normal": imageSelect = "Normal"; break;
        case "oily": imageSelect = "Oily"; break;
        case "dry": imageSelect = "VDry"; break;
        case "combo": imageSelect = "Combo"; break;
        default: break;
      }
      updateYourItems(imageSelect, $('#product-select').data('variant-title') + " SPF 30 Sunscreen", displayProductType);
    } else if (hasVariantInfo){
      // console.log(`updateYourItems -> "${imageSelect}" "${productAccessory}" "${displayProductType}"`);
      updateYourItems(imageSelect, productAccessory, displayProductType);

      // if (product.variants.length > 1 && !animatedSkinType) {
      //   $('#product-select').css("cssText", "width: 100% !important;");
      //   $('.selector-wrapper').css({ 'width': '100%' });
      //   $('.desktop-button').css({ 'max-width': '0%' });
      //   if (variantId != 0) {
      //     animatedSkinType = true;
      //     $('.selector-wrapper').animate({ 'width': '170px', queue: 'add-to-cart-open' }, 400, 'swing');
      //     $('.desktop-button').animate({ 'max-width': '100%', queue: 'add-to-cart-open' }, 400, 'swing');
      //     $('.selector-wrapper, .desktop-button').dequeue('add-to-cart-open');
      //   }
      // }
    } else if (product.tags.includes('tint-select')) {
      updateYourItems($('#product-select').data('variant-title'), "", "");
    }
    //Out of Stock/Add to Cart Button change
    if (product.tags.includes('shade-select')) return; // update button above
    if (variantId != 0 || hasVariantInfo != true || product.variants.length == 1) {

      // if(!product.tags.includes('select-duo') || !product.tags.includes('select-trio')) {
      //   $('.product-select').removeClass('select-skin-type');
      // }

      if ($('.product-select').find(':selected').data('stock') == "sold-out" || (product.variants.length == 1 && product.variants[0].available != true)) {
        $('#btn-add_to_cart').prop("disabled", true).text("out of stock");
        $('#btn-add_to_cart2').prop("disabled", true).text("out of stock");
      } else {
        if (product.tags.includes('tint-select') && $('#product-select').hasClass('choose-your-tint')) {
          $('#btn-add_to_cart').prop("disabled", true).text("Choose your Shade");
          $('#btn-add_to_cart2').prop("disabled", true).text("Choose your Shade");
        } else if (typeof PRE_ORDER !== 'undefined' && PRE_ORDER == true) {
          $('#btn-add_to_cart').prop("disabled", false).text("Pre-order now");
          $('#btn-add_to_cart2').prop("disabled", false).text("Pre-order now");
        } else if (product.tags.includes('select-duo') || product.tags.includes('select-trio')) {
          if ($('#product-select-bundle').val()) {
            $('#btn-add_to_cart').prop("disabled", false).text("Add to Cart");
            $('#btn-add_to_cart2').prop("disabled", false).text("Add to Cart");
          }
        } else {
          $('#btn-add_to_cart').prop("disabled", false).text("Add to Cart");
          $('#btn-add_to_cart2').prop("disabled", false).text("Add to Cart");
        }
      }
    }
  }

  function fixUpsellUrl() {
    setTimeout(() => {
      // console.log('fixUpsellUrl');
      const urlParams = new URLSearchParams(window.location.search);
      if (UPSELL_NUM == 0) {
        urlParams.delete('upsell');
      } else {
        if (urlParams.has('upsell')){
          urlParams.delete('upsell');
        }
        urlParams.set('upsell', UPSELL_NUM);
      }
      urlParams.sort(); // keep 'upsell' before 'variant'
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + urlParams;
      window.history.replaceState({ path: newurl }, '', newurl );
    }, 80); // wait for theme.js and appstle.js to update url (and remove 'upsell=') ~50-100ms?
  }

  if (productHasSellingPlans) {
    $('body').on('click', function() {
      fixUpsellUrl();
    });
  }
  
  $('.product-select').on('click', function() {
    fixUpsellUrl();
  });

  $('.product-select').on('blur', function() {
    fixUpsellUrl();
  });

  $('.product-select').on('change', function() {
    //UPDATE VARIANT
    //1. update url without refreshing
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('variant')){
      urlParams.delete('variant');
    }
    urlParams.set('variant', this.value);
    // window.location.search = urlParams; // refreshes page
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + urlParams;
    window.history.pushState({ path: newurl }, '', newurl);
    
    fixUpsellUrl();

    productSelectUpdate();

    updateSubscribfyPrice()

    if (typeof updateSkinAutoReplenish == 'function') updateSkinAutoReplenish(); // snippets\auto-replenish-product.liquid
  });

  function updateSubscribfyPrice() {
    var variantId = $('.product-select').val();

    if (!window.product || !product.variants) return;

    var variant = product.variants.find(v => v.id == variantId);

    if (!variant || !variant.price) return;

    var discountedPrice = Math.ceil((variant.price * 0.9) / 100) * 100;

    $('.exm_updated_price').text(`$${discountedPrice / 100}`);
  }

  //Auto select if has specific url
  var skintypeSelector = getUrlParam('selector');
  if (typeof skintypeSelector !== 'undefined') {
    switch (skintypeSelector) {
      case 'very-dry':
        var selection = 'Very Dry';
        var backupSelection = 'Hydrating Cream Cleanser';
      break;

      case 'normal':
      case 'dry':
        var selection = 'Normal to Dry';
        var backupSelection = 'Hydrating Cream Cleanser';
      break;

      case 'combo':
        var selection = 'Combination';
        var backupSelection = 'Refreshing Gel Cleanser';
      break;

      case 'oily': 
        var selection = 'Oily';
        var backupSelection = 'Refreshing Gel Cleanser';
      break;
    }
    if (typeof selection !== 'undefined' && selection != '') {
      $('.product-select option:first').attr('selected', false);
      if ($('.product-select option:contains("'+ selection +'")').length > 0) {
        $('.product-select option:contains("'+ selection +'")').attr('selected', true);
        $('.product-select').trigger('change');
      } else if ($('.product-select option:contains("'+ backupSelection +'")').length > 0) {
        $('.product-select option:contains("'+ backupSelection +'")').attr('selected', true);
        $('.product-select').trigger('change');
      }
    }
  }

  $('.product-select-custom').on('change', (e) => {

    var selectedSample = [$('#product-select-custom').find(':selected').data('product-id').toString()];
    var skinType = $('#product-select-custom').find(':selected').text();
    var sampleName = 'Riversol 15-Day ' + PRODUCT_CONCERN + ' Sample Kit - ' + skinType;

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'gtm_product_id': selectedSample,
      'gtm_product_name': [sampleName],
      'gtm_product_price': 0.01,
      'gtm_product_currency': '',
      'gtm_skin_type': [skinType],
      'gtm_num_items': [1]
    });
  });

  //Open 
  $('.mobile-price .jdgm-prev-badge').click(function() {
    if ($( window ).width() < 769 ) {
      $('.ov__product-reviews .ov__section-title').addClass('opentab');
      $('.ov__product-reviews .content-section').css('display', 'block');      
    }
  });

  // Default Open Tabs on Mobile
  if (screen.width < 769) {
    let firstSection = $('.ov__content .ov__section').first();
    if (firstSection) {
      firstSection.find('.ov__section-title').addClass('opentab');
      firstSection.find('.content-section').css('display', 'block');
    }
    let reviewsSection = $('.ov__product-reviews');
    if (reviewsSection && firstSection != reviewsSection) {
      reviewsSection.find('.ov__section-title').addClass('opentab');
      reviewsSection.find('.content-section').css('display', 'block');
    }  
  }

  //limit if product has set limits
 $( ".quantity__input" ).change(function() {
    if (hasLimit) {
      var promotionQuantity = $('.quantity__input').val();
      var quantityInCart = quantityItem;
      var limit = itemLimit - quantityInCart; 

      if ( promotionQuantity > limit ) {
        $('#btn-add_to_cart').prop( "disabled", true ).find('span').text('Limit ' + itemLimit + ' per order');
        $('#btn-add_to_cart2').prop( "disabled", true ).find('span').text('Limit ' + itemLimit + ' per order');
      } else {  
        $('#btn-add_to_cart').prop( "disabled", false ).find('span').text('Add to Cart');
        $('#btn-add_to_cart2').prop( "disabled", false ).find('span').text('Add to Cart');
      }
    } 
  });


  // Add-to-Cart
  var addToCartWait = true;
  var gaWait = true;
  var subscriptionSubmitBypass = false;
  $(".shopify-product-form").on('submit', (e) => {
    if (subscriptionSubmitBypass) return; // submit subscriptions using form after adding upsells using CartJS (subscriptions cannot be added using CartJS...)

    if(product.tags.includes('select-duo') || product.tags.includes('select-trio')) {
      $('#btn-add_to_cart').prop("disabled", true).text('adding to cart...')
      $('#btn-add_to_cart2').prop("disabled", true).text('adding to cart...')
      const qty = $(".quantity-selector input").val();
      const id = $('#product-select-bundle').val();
      CartJS.addItem(id, qty);
    }


    if(!$('#properties_auto_replenish').val()) { $('#properties_auto_replenish').remove()}
    if(!$('#properties_auto_replenish_months').val()) { $('#properties_auto_replenish_months').remove()}

    

    const safeAccess = JSON.parse(sessionStorage.getItem('safeAccess'));
    if(safeAccess == false) {
      if(paidVersion) {
        $('#product-select').val(paidVersion.variants[0].id);
      }
    }
    
    // ***************************
    // OLD TAG MANAGER - GTM-K2HCMZ5
    // var gtm = window.google_tag_manager['GTM-K2HCMZ5'];

    if($(".quantity-selector input").is(':visible')) {
      var qty = $(".quantity-selector input").val();
    } else {
      qty = 1;
    }

    var addedQuantity = [parseInt(qty)];


    if ($('.product__upsell').is(':visible')) {
      e.preventDefault();
      var selectedUpsells = $('.upsell-item.selected').map(function () { return this.id; }).get();
      var addedPrices = [parseInt(PRODUCT_PRICE)];
      var addedConcern = [PRODUCT_CONCERN]; 
      var addedNames= [PRODUCT_TITLE];
      var addedSkinType = [PRODUCT_SKIN_TYPE];
      var addedProductType = [PRODUCT_CATEGORY];


      selectedUpsells.forEach((id) => {
        CartJS.addItem(id, 1, { 
            "_limit": 1 
        });
      })

      if (productHasSellingPlans == false) CartJS.addItem($('#product-select').val() || $('#product-select-custom').val(), qty);

      var upsellValue = 0;
      var upsellLabel = (UPSELL_NUM) + ':';
      $('.upsell-item.selected').each(function() {
        addedQuantity.push(1);

        var price = $(this).find('.upsell-item-price').text().replace('$', '');
        addedPrices.push(parseInt(price));

        addedNames.push($(this).data("full-title"));
        addedProductType.push($(this).data("category"));
        addedConcern.push($(this).data("concern"));
        addedSkinType.push($(this).data("skin-type"));

        if (upsellLabel != "") {
          upsellLabel += ",";
        }
        upsellLabel += $(this).data("handle");
        upsellValue += parseInt(price);
      });

      if (productHasSellingPlans) { 
        subscriptionSubmitBypass = true; // submit subscriptions using form after adding upsells using CartJS
        $('#upsell-box').html(''); // remove upsells from form

        if(selectedUpsells.length > 0) {
          $(document).on('cart.requestComplete', function(event, cart) {
            $(".shopify-product-form").submit();// add subscription after upsells
          });
        } else {
          setTimeout(() => {
            $(".shopify-product-form").submit(); // add subscription after tracking
          }, 200);
        }
      }

      var addedIds = $('.upsell-item.selected').map(function () { return this.id; }).get();
      addedIds.push($('#product-select').val() || PRODUCT_ID);
      
      gaWait = false; // don't wait for analytics event, good if it fires in time but not worth waiting
      
    } else if (hasLimit) {
      e.preventDefault();
      const qty = $(".quantity-selector input").val();
      const id = $('#product-select').val();
      const idCustom = $('#product-select-custom').val();
      CartJS.addItem(id || idCustom, qty, { 
        "_limit": itemLimit
      });
    }

    if (!productHasSellingPlans || selectedUpsells.length == 0)  { // don't overwrite if already waiting to add a subscription plan after upsells products
      $(document).on('cart.requestComplete', function(event, cart) {
        addToCartWait = false;
        waitForCartAndGA();  // redirect after ga event
      });
    }
    

    function waitForCartAndGA () {
      if (addToCartWait || gaWait) return;
      window.location.assign('/cart');
    }
  });

  // ADD ACCESSORY
  $('.accessory-item .product__submit__add').click(function() {
    $(this).addClass("adding");
    $(this).text("Adding...");
    var button = $(this);

    $(document).on('cart.requestComplete', function(event, cart) {
      button.text("Added to cart"); 
      button.removeClass("adding"); 
    });

  }); 

  // VARIANT FOR IN PAGE ACCESSORY ADD TO CART
  $( ".variant-selection" ).change(function() {
    $('.product-image-select').removeClass('selected');
    $(this).removeClass('not-selected');
    var submitButton = $(this).parent().find('.product__submit__add')
    var selectedVariant = $(this).val();
    var selectedSkinType = $(this).find(":selected").text().split(' - ');
    var selectedImage = "#product-" + selectedVariant;

    $(selectedImage).addClass('selected');
    submitButton.text("Add to cart").prop('disabled', false).removeClass('disabled').attr("data-cart-add", selectedVariant);
    $(this).parents('.figcaption').find('.variant-product-title').text(selectedSkinType[1] + " (For " + selectedSkinType[0] + ")");
  });
  
  $( ".variant-selection-tint" ).change(function() {
    $('.tint-product-image-select').removeClass('selected');
    $('#product-default').hide();

    $(this).removeClass('not-selected');
    var submitButton = $(this).parent().find('.product__submit__add')
    var selectedVariant = $(this).val();
    var selectedSkinType = $(this).find(":selected").text().split(' - ');
    var selectedImage = "#product-" + selectedVariant;

    $(selectedImage).addClass('selected');
    submitButton.text("Add to cart").prop('disabled', false).removeClass('disabled').attr("data-cart-add", selectedVariant);
    $(this).parents('.figcaption').find('.variant-product-title').text(selectedSkinType[0] + " SPF 30");
  });


  // 
  // TAB CONTENT MOBILE
  //////////////////////
  // function UAParserString(agent) {
  //   var data = UAParser(agent);
  //   // [${ data.device.type }]  UA: ${ data.ua }
  //   var displayString = `${data.device.vendor || ''}:${data.device.model || ''} (${data.os.name || ''}:${data.os.version || ''}) / ${data.browser.name || ''}:${data.browser.version || ''} (${data.engine.name || ''}:${data.engine.version || ''}) => ${JSON.stringify(data.ua)}`;
  //   if (data.device.model == 'iPhone') {
  //     if (!window.MSStream) {
  //       var currentDeviceInfo = JSON.stringify({
  //         'width': (window.screen.width > window.screen.height) ? window.screen.height : window.screen.width,
  //         'height': (window.screen.width > window.screen.height) ? window.screen.width : window.screen.height,
  //         'ratio': window.devicePixelRatio
  //       });
  //       var devices = {
  //         '2G/3G/3GS': {
  //           'width': 320,
  //           'height': 480,
  //           'ratio': 1
  //         },
  //         '4/4S': {
  //           'width': 320,
  //           'height': 480,
  //           'ratio': 2
  //         },
  //         '5/5S/5C/SE¹': {
  //           'width': 320,
  //           'height': 568,
  //           'ratio': 2
  //         },
  //         '6/6S/7/8/SE²': {
  //           'width': 375,
  //           'height': 667,
  //           'ratio': 2
  //         },
  //         'X/XS/11P/12m/13m': {
  //           'width': 375,
  //           'height': 812,
  //           'ratio': 3
  //         },
  //         '12/12P/13/13P': {
  //           'width': 390,
  //           'height': 844,
  //           'ratio': 3
  //         },
  //         '6+/6S+/7+/8+': {
  //           'width': 414,
  //           'height': 736,
  //           'ratio': 3
  //         },
  //         'XR/11': {
  //           'width': 414,
  //           'height': 896,
  //           'ratio': 2
  //         },
  //         'XSM/11PM': {
  //           'width': 414,
  //           'height': 896,
  //           'ratio': 3
  //         },
  //         '12PM/13PM': {
  //           'width': 428,
  //           'height': 926,
  //           'ratio': 3
  //         }
  //       };
  //       Object.entries(devices).forEach(model => {
  //         const [key, value] = model;
  //         if (JSON.stringify(value) == currentDeviceInfo) {
  //           displayString = displayString.replace('iPhone', 'iPhone ' + key);
  //         }
  //       });
  //     }
  //   }
  //   return displayString;
  // }
  
  $('.ov__section-title').on('click', (e) => {
    var screenSize = $(window).width();

    if (screenSize <= 768 ) {
      $(e.currentTarget).toggleClass('opentab')
      $(e.currentTarget).closest('.wrapper').find('.content-section').toggle();

      
    }
  });

  //
  // ACCESSORY SLIDER
  /////////////////////

  var hasSlider = $('.mb-slider').is(':visible');
  
  $('.mb-slider').flickity({
    freeScroll: false,
    contain: true,
    prevNextButtons: true,
    pageDots: false,
    wrapAround: true,
    autoPlay: false,
    dragThreshold: 10
  })

  $('.accessories-tab').on( 'click', function() {
    $('.mb-slider').show()
      .flickity('resize');
  });

  $('.ov__related-products .ov__section-title').on( 'click', function() {
    $('.mb-slider').show()
      .flickity('resize');
  });

  
});


// 
// AUTO TABLE OF CONTENTS
//////////////////////////
var linkCounter = 1;
$('.ov__section-title').each(function() {
  $('<a name="' + linkCounter +'"></a>').appendTo($(this));
  var title = $(this).text();
  var altTitle = $(this).data('alt-title');
  if (altTitle && altTitle != '') {
    title = altTitle;
  }
  $('<a href="#' + linkCounter + '">' + title + '</a>').appendTo('.table-of-contents');
  if (window.location.hash == '#' + linkCounter) {
    switch (linkCounter) {
      case 1: window.location.hash = "#results"; break;
      case 2: window.location.hash = "#how-it-works"; break;
      case 3: window.location.hash = "#ingredients"; break;
      case 4: window.location.hash = "#how-to-use"; break;
      case 5: window.location.hash = "#faq"; break;
      case 6: window.location.hash = "#complete"; break;
      case 7: window.location.hash = "#shipping"; break;
      case 8: window.location.hash = "#reviews"; break;
      case 9: window.location.hash = "#also-like"; break;
      default: break;
    }
  }
  linkCounter ++;
});

// 
// REVIEW NUMBERS + AVG RATING INSERT
////////////////////////////////////

// document.addEventListener('DOMContentLoaded', function(){
//   //Add average rating to main product
//   var avgRating = $('.product__form__wrapper .jdgm-prev-badge').attr('data-average-rating');
//   $('<span>' + avgRating + ' </span>' ).insertBefore('.mobile-star .jdgm-prev-badge__text');

//   //Replace all values greater than 999 with local number format
//   $('.jdgm-prev-badge').each(function() {
//     var numberReviews = $(this).attr('data-number-of-reviews');
//     const intReviews = parseInt( numberReviews, 10);

//     if (intReviews > 999) {
//       $(this).find('.jdgm-prev-badge__text').text( intReviews.toLocaleString() + ' reviews');
//     }
//    });

// }, false); 

// fix: buy box reviews anchor - mobile top spacing
$(document).ready(() => {
  $('.jdgm-widget.jdgm-preview-badge.jdgm-preview-badge--with-link').addClass("jdgm-preview-badge--with-link-noclick").css({ pointerEvents: 'none', touchAction: 'none' }); // can't remove old listener, todo: move css out of js file
  $('#mobile-star-click').on("click", function( event ) {
    event.stopPropagation(); 
    window.location.href = "#reviews"; //  window.location.href = "#judgeme_product_reviews"; // old anchor
  });
});

